import { render, staticRenderFns } from "./ChurchLogin.vue?vue&type=template&id=cf5d10b4&scoped=true"
import script from "./ChurchLogin.vue?vue&type=script&lang=js"
export * from "./ChurchLogin.vue?vue&type=script&lang=js"
import style0 from "./ChurchLogin.vue?vue&type=style&index=0&id=cf5d10b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf5d10b4",
  null
  
)

export default component.exports